/* global pgvMain */

import scriptjs from 'scriptjs'

const id = 'a20181206snowfes'

scriptjs(
  'https://ossweb-img.qq.com/images/js/PTT/ping_tcss_tgideas_https_min.js',
  () => {
    window.setSite = {
      siteType: id,
      pageType: 'index',
      pageName: '冬天有你才不冷',
    }
    pgvMain()
  }
)
